<template>
    <q-icon
        name="help"
        size="xs"
        color="grey"
        class="cursor-pointer"
        @click.stop.prevent="dialog = true"
    >
        <q-dialog v-model="dialog">
            <q-card style="min-width: 350px">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Help</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section>
                    <div v-html="text"></div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </q-icon>
</template>

<script>
import { ref } from "vue";

export default {
    name: "HelpIcon",
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    setup() {
        const dialog = ref(false);
        return { dialog };
    },
};
</script>
